import * as React from "react";
import { Query, graphql } from "react-apollo";
import { Row, Col, Button } from "reactstrap";
import * as uuid from "uuid";
import { MdModeEdit, MdDeleteForever } from "react-icons/md";

// GraphQL
import GetCompanyAssets from "../../GraphQL/Queries/GetCompanyAssets";
import DeleteAsset from "../../GraphQL/Mutations/DeleteAsset";

// Presentation/UI
import Loader from "../../Components/Loader/DotLoader";
import Table from "../../Components/Table";
import GlobalModal from "../../Components/GlobalModal";
import DialogModal from "../../Components/DialogModal";

import EditAssetForm from "./EditAssetForm";

interface IProps {
  companyId: string;
  toastManager: any;
  mutate: any;
}

class AllAssets extends React.Component<IProps> {
  state = {
    modal: false,
    dialogModal: false,
    loading: false,
    title: "Are you sure you want to delete this asset?",
    asset: {},
    assetId: null
  };

  // Close dialog modal
  closeDialogModal = (): void => {
    this.setState({
      dialogModal: false
    });
  };

  // Open dialog modal
  openDialogModal = (companyAsset: any): void => {
    const assetId = !companyAsset ? null : companyAsset.id;
    this.setState({
      dialogModal: true,
      assetId
    });
  };

  // Handle response
  handleResponse = (e: React.FormEvent<HTMLInputElement>): void => {
    e.preventDefault();
    this.setState({ loading: true });
    // delete site mutation
    const { companyId } = this.props;
    this.props
      .mutate({
        variables: {
          id: this.state.assetId
        },
        refetchQueries: [
          {
            query: GetCompanyAssets,
            variables: { id: companyId }
          }
        ]
      })
      .then((res: any) => {
        this.setState({ loading: false, assetId: null });
        this.closeDialogModal();
        this.toastNotification("Asset deleted successfully");
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  // Close modal
  closeModal = (): void => {
    this.setState({
      modal: false
    });
  };

  // Open modal
  openModal = (asset: object): void => {
    this.setState({
      modal: true,
      asset
    });
  };

  // success notification
  toastNotification = (message: string) => {
    this.props.toastManager.add(message, {
      appearance: "success",
      autoDismiss: true
    });
  };

  render() {
    const { asset } = this.state;
    const { companyId } = this.props;
    return (
      <Query query={GetCompanyAssets} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the assets</div>;
          }

          const assets = data.allAssets;

          return (
            <Row>
              <GlobalModal
                toggleModal={this.closeModal}
                title="Edit Asset"
                modalDisplay={
                  <EditAssetForm
                    notification={this.toastNotification}
                    closeModal={this.closeModal}
                    companyId={companyId}
                    asset={asset}
                  />
                }
                modal={this.state.modal}
              />
              <DialogModal
                modal={this.state.dialogModal}
                title={this.state.title}
                loading={this.state.loading}
                toggleModal={this.closeDialogModal}
                handleResponse={this.handleResponse}
              />
              <Col xs={12} md={12} lg={12}>
                <Table
                  data={assets}
                  columns={[
                    {
                      Header: "Name",
                      accessor: "name",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Description",
                      accessor: "description",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Model",
                      accessor: "model",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Category",
                      accessor: "category",
                      sortable: false,
                      filterable: false
                    },
                    {
                      Header: "Bar Code",
                      accessor: "barcode",
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Site",
                      accessor: (companyAsset: any) => {
                        return !companyAsset.site ? "" : companyAsset.site.name;
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "Primary User",
                      accessor: (companyAsset: any) => {
                        return !companyAsset.primaryUser
                          ? ""
                          : `${companyAsset.primaryUser.firstName} ${
                              companyAsset.primaryUser.lastName
                            }`;
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyAsset: object) => {
                        return (
                          <Button
                            onClick={() => this.openModal(companyAsset)}
                            className="icon-btn icon-edit-btn"
                          >
                            <MdModeEdit color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    },
                    {
                      id: uuid(),
                      Header: "",
                      accessor: (companyAsset: object) => {
                        return (
                          <Button
                            onClick={() => this.openDialogModal(companyAsset)}
                            className="icon-btn icon-delete-btn"
                          >
                            <MdDeleteForever color="#fff" size="1.35em" />
                          </Button>
                        );
                      },
                      sortable: false,
                      filterable: false
                    }
                  ]}
                  defaultPageSize={5}
                  showPaginationTop={false}
                  showPaginationBottom={true}
                />
              </Col>
            </Row>
          );
        }}
      </Query>
    );
  }
}

export default graphql<any, Response, any, any>(DeleteAsset)(AllAssets);



// WEBPACK FOOTER //
// ./src/Containers/Assets/AllAssets.tsx